export default __webpack_public_path__ + "static/media/xm.e101002a.gif";